/** html2canvas 오프스크린 캡처용 — 레이아웃·숨김(색상은 computed style 인라인 복사) */
export const ANNUAL_OPERATION_PLAN_CAPTURE_CSS = `
.cp-annual-operation-plan-export-meta {
  margin: 0 0 10px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Noto Sans KR', sans-serif;
}
.cp-annual-operation-plan-export-title {
  display: block !important;
  margin: 0 0 6px;
  font-size: 28px !important;
  font-weight: 700;
  text-align: center;
  line-height: 1.35 !important;
}
.cp-annual-operation-plan-scope-class {
  display: flex;
  justify-content: center;
  margin: 0 0 6px;
}
.cp-annual-operation-plan-subtitle {
  margin: 0;
  font-size: 22px !important;
  font-weight: 700;
  text-align: center;
  line-height: 1.35 !important;
}
.cp-annual-operation-plan-intro {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}
.cp-annual-operation-plan-table {
  width: 100%;
  min-width: 980px;
  border-collapse: collapse;
  font-size: 0.77rem;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Noto Sans KR', sans-serif;
  table-layout: fixed;
}
.cp-annual-operation-plan-col-month { width: 36px; }
.cp-annual-operation-plan-col-week { width: 32px; }
.cp-annual-operation-plan-col-count { width: 60px; }
.cp-annual-operation-plan-col-day { width: 34px; }
.cp-annual-operation-plan-col-hours { width: 48px; }
.cp-annual-operation-plan-col-activity { width: auto; }
.cp-annual-operation-plan-col-remark { width: 15%; min-width: 128px; }
.cp-annual-operation-plan-table th,
.cp-annual-operation-plan-table td {
  border: 1px solid #c8c8c8;
  padding: 3px 4px;
}
.cp-annual-operation-plan-table th {
  background: #f4f4f4;
  font-weight: 700;
  white-space: nowrap;
}
.cp-annual-operation-plan-activity-cell,
.cp-annual-operation-plan-remark-cell {
  text-align: left;
  vertical-align: top;
  font-size: 0.74rem;
  line-height: 1.35;
  min-width: 0;
  overflow-wrap: anywhere;
  word-break: break-word;
}
.cp-annual-operation-plan-activity-line {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px 6px;
  max-width: 100%;
}
.cp-annual-operation-plan-activity-tags {
  display: inline-flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 0;
}
.cp-annual-operation-plan-activity-tag {
  box-sizing: border-box;
  width: 14px;
  height: 14px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.52rem;
  font-weight: 800;
  line-height: 1;
  padding: 0;
}
.cp-annual-operation-plan-activity-tags .cp-annual-operation-plan-activity-tag + .cp-annual-operation-plan-activity-tag {
  margin-left: -1px;
}
.cp-annual-operation-plan-activity-tag--common {
  width: auto;
  min-width: 26px;
  height: 14px;
  padding: 0 3px;
  font-size: 0.5rem;
}
.cp-annual-operation-plan-remark-week-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
  margin-bottom: 4px;
}
.cp-annual-operation-plan-remark-week-row:last-child {
  margin-bottom: 0;
}
.cp-annual-week-memo-week-mark {
  flex: 0 0 auto;
  width: 14px;
  height: 14px;
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.52rem;
  font-weight: 800;
  line-height: 1;
}
.cp-annual-operation-plan-total-row td {
  font-weight: 700;
}
.cp-annual-operation-plan-footer-term1 td {
  background: #e8d4dc !important;
  color: #1a1a1a;
}
.cp-annual-operation-plan-footer-term2 td {
  background: #d8e6ef !important;
  color: #1a1a1a;
}
.cp-annual-operation-plan-footer-grand-total td {
  background: #ffefb8 !important;
  color: #1a1a1a;
}
.cp-annual-operation-plan-table tbody tr:not(.cp-annual-operation-plan-total-row) .cp-annual-operation-plan-count-cell {
  font-weight: 700;
  background: rgba(255, 236, 140, 0.1);
}
.cp-annual-operation-plan-table tbody tr:not(.cp-annual-operation-plan-total-row) .cp-annual-operation-plan-hours-cell {
  background: rgba(255, 236, 140, 0.1);
}
.cp-capture-hide-thead thead {
  display: none !important;
}
.cp-capture-hide-tbody tbody {
  display: none !important;
}
.cp-export-exclude {
  display: none !important;
}
`;
